class CartTermsConsent extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.error = this.querySelector('[role="alert"]');
    this.actions = this.nextElementSibling;
    this.checkout = this.actions?.querySelector('.cart__checkout-button');
    this.acceleratedCheckout = this.actions?.querySelector('.additional-checkout-buttons');
    this.form = this.checkbox?.form;

    if (!this.checkbox || !this.actions || !this.checkout) return;

    this.checkbox.addEventListener('change', this.handleChange, {
      signal: this.abortController.signal,
    });

    this.checkbox.addEventListener('invalid', this.handleInvalid, { signal: this.abortController.signal });
    this.checkout.addEventListener('click', this.handleSubmit, { capture: true, signal: this.abortController.signal });

    this.form?.addEventListener('submit', this.handleSubmit, {
      capture: true,
      signal: this.abortController.signal,
    });

    this.updateState();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  handleChange = () => {
    if (this.checkbox?.checked) {
      this.checkbox.setCustomValidity('');
      if (this.error) this.error.hidden = true;
      this.checkbox.removeAttribute('aria-invalid');
    }
    this.updateState();
  };

  handleSubmit = (event) => {
    if (this.checkbox?.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.showError();
    this.checkbox?.focus();
  };

  handleInvalid = (event) => {
    event.preventDefault();
    this.showError();
    this.checkbox?.focus();
  };

  showError() {
    this.checkbox?.setAttribute('aria-invalid', 'true');
    this.checkbox?.setCustomValidity(this.error?.textContent?.trim() || '');
    if (this.error) this.error.hidden = false;
  }

  updateState() {
    const accepted = Boolean(this.checkbox?.checked);

    if (this.acceleratedCheckout) {
      this.acceleratedCheckout.toggleAttribute('inert', !accepted);
      this.acceleratedCheckout.setAttribute('aria-disabled', String(!accepted));
    }
  }
}

if (!customElements.get('cart-terms-consent')) {
  customElements.define('cart-terms-consent', CartTermsConsent);
}
